import actionTypes from '../actionTypes';

export function getItemUnitOnHandInventory(data) {
	return {
		type: actionTypes.GET_ITEM_UNIT_ON_HAND_INVENTORY,
		payload: data,
	};
}

export function setItemUnitOnHandInventory(result, isSuccess = true) {
	if (isSuccess) {
		return {
			type: actionTypes.GET_ITEM_UNIT_ON_HAND_INVENTORY_SUCCESS,
			payload: result,
		};
	}
	return {
		type: actionTypes.GET_ITEM_UNIT_ON_HAND_INVENTORY_FAILURE,
		payload: result,
	};
}

export function getItemRetailOnHandInventory(result) {
	return {
		type: actionTypes.GET_ITEM_RETAIL_ON_HAND_INVENTORY,
		payload: result,
	};
}

export function setItemRetailOnHandInventory(result, isSuccess = true) {
	if (isSuccess) {
		return {
			type: actionTypes.GET_ITEM_RETAIL_ON_HAND_INVENTORY_SUCCESS,
			payload: result,
		};
	}
	return {
		type: actionTypes.GET_ITEM_RETAIL_ON_HAND_INVENTORY_FAILURE,
		payload: result,
	};
}

export function getItemBasicInfo(payload) {
	return {
		type: actionTypes.GET_ITEM_BASIC_INFO,
		payload,
	};
}

export function getItemBasicInfoSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_BASIC_INFO_SUCCESS,
		payload,
	};
}
export function getItemBasicInfoFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_BASIC_INFO_FAILURE,
		payload,
	};
}

export function getItemNetSalesSummaryCards(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES_SUMMARY_CARD,
		payload,
	};
}
export function getItemNetSalesSummaryCardsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES_SUMMARY_CARD_SUCCESS,
		payload,
	};
}
export function getItemNetSalesSummaryCardsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES_SUMMARY_CARD_FAILURE,
		payload,
	};
}
export function getItemInStockSummaryCards(payload) {
	return {
		type: actionTypes.GET_ITEM_IN_STOCK_SUMMARY_CARD,
		payload,
	};
}
export function getItemInStockSummaryCardsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_IN_STOCK_SUMMARY_CARD_SUCCESS,
		payload,
	};
}
export function getItemInStockSummaryCardsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_IN_STOCK_SUMMARY_CARD_FAILURE,
		payload,
	};
}
export function getItemStoreCountSummaryCards(payload) {
	return {
		type: actionTypes.GET_ITEM_STORE_COUNT_SUMMARY_CARD,
		payload,
	};
}
export function getItemStoreCountSummaryCardsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_STORE_COUNT_SUMMARY_CARD_SUCCESS,
		payload,
	};
}
export function getItemStoreCountSummaryCardsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_STORE_COUNT_SUMMARY_CARD_FAILURE,
		payload,
	};
}
export function getItemNilPickRateSummaryCards(payload) {
	return {
		type: actionTypes.GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD,
		payload,
	};
}
export function getItemNilPickRateSummaryCardsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD_SUCCESS,
		payload,
	};
}
export function getItemNilPickRateSummaryCardsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD_FAILURE,
		payload,
	};
}

export function getItemChannelBreakdown(payload) {
	return {
		type: actionTypes.GET_ITEM_CHANNEL_BREAKDOWN,
		payload,
	};
}
export function itemChannelBreakdownSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_CHANNEL_BREAKDOWN_SUCCESS,
		payload,
	};
}
export function itemChannelBreakdownFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_CHANNEL_BREAKDOWN_FAILURE,
		payload,
	};
}

export function getItemNetSales(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES,
		payload,
	};
}
export function itemNetSalesSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES_SUCCESS,
		payload,
	};
}
export function itemNetSalesFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES_FAILURE,
		payload,
	};
}

export function getItemUnits(payload) {
	return {
		type: actionTypes.GET_ITEM_UNITS,
		payload,
	};
}
export function itemUnitsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_UNITS_SUCCESS,
		payload,
	};
}
export function itemUnitsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_UNITS_FAILURE,
		payload,
	};
}

export function getItemRelativeNetSales(payload) {
	return {
		type: actionTypes.GET_ITEM_RELATIVE_NET_SALES,
		payload,
	};
}
export function itemRelativeNetSalesSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_RELATIVE_NET_SALES_SUCCESS,
		payload,
	};
}
export function itemRelativeNetSalesFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_RELATIVE_NET_SALES_FAILURE,
		payload,
	};
}

export function getItemRelativeUnits(payload) {
	return {
		type: actionTypes.GET_ITEM_RELATIVE_UNITS,
		payload,
	};
}
export function itemRelativeUnitsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_RELATIVE_UNITS_SUCCESS,
		payload,
	};
}
export function itemRelativeUnitsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_RELATIVE_UNITS_FAILURE,
		payload,
	};
}

export function getUnitsChannelBreakdown(payload) {
	return {
		type: actionTypes.GET_UNITS_CHANNEL_BREAKDOWN,
		payload,
	};
}
export function unitsChannelBreakdownSuccess(payload) {
	return {
		type: actionTypes.GET_UNITS_CHANNEL_BREAKDOWN_SUCCESS,
		payload,
	};
}
export function unitsChannelBreakdownFailure(payload) {
	return {
		type: actionTypes.GET_UNITS_CHANNEL_BREAKDOWN_FAILURE,
		payload,
	};
}

export function getItemOnHand(payload) {
	return {
		type: actionTypes.GET_ITEM_ONHAND,
		payload,
	};
}
export function getItemOnHandSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_ONHAND_SUCCESS,
		payload,
	};
}
export function getItemOnHandFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_ONHAND_FAILURE,
		payload,
	};
}

export function getItemOnHandUnits(payload) {
	return {
		type: actionTypes.GET_ITEM_ONHAND_UNITS,
		payload,
	};
}
export function getItemOnHandUnitsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_ONHAND_UNITS_SUCCESS,
		payload,
	};
}
export function getItemOnHandUnitsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_ONHAND_UNITS_FAILURE,
		payload,
	};
}

export function getItemOnOrder(payload) {
	return {
		type: actionTypes.GET_ITEM_ONORDER,
		payload,
	};
}
export function getItemOnOrderSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_ONORDER_SUCCESS,
		payload,
	};
}
export function getItemOnOrderFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_ONORDER_FAILURE,
		payload,
	};
}

export function getItemOnOrderUnits(payload) {
	return {
		type: actionTypes.GET_ITEM_ONORDER_UNITS,
		payload,
	};
}
export function getItemOnOrderUnitsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_ONORDER_UNITS_SUCCESS,
		payload,
	};
}
export function getItemOnOrderUnitsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_ONORDER_UNITS_FAILURE,
		payload,
	};
}

export function getItemDCToStore(payload) {
	return {
		type: actionTypes.GET_ITEM_DCTOSTORE,
		payload,
	};
}
export function getItemDCToStoreSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_DCTOSTORE_SUCCESS,
		payload,
	};
}
export function getItemDCToStoreFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_DCTOSTORE_FAILURE,
		payload,
	};
}

export function getItemDCToStoreUnits(payload) {
	return {
		type: actionTypes.GET_ITEM_DCTOSTORE_UNITS,
		payload,
	};
}
export function getItemDCToStoreUnitsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_DCTOSTORE_UNITS_SUCCESS,
		payload,
	};
}
export function getItemDCToStoreUnitsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_DCTOSTORE_UNITS_FAILURE,
		payload,
	};
}

export function getItemInWhse(payload) {
	return {
		type: actionTypes.GET_ITEM_INWHSE,
		payload,
	};
}
export function getItemInWhseSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_INWHSE_SUCCESS,
		payload,
	};
}
export function getItemInWhseFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_INWHSE_FAILURE,
		payload,
	};
}

export function getItemInWhseUnits(payload) {
	return {
		type: actionTypes.GET_ITEM_INWHSE_UNITS,
		payload,
	};
}
export function getItemInWhseUnitsSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_INWHSE_UNITS_SUCCESS,
		payload,
	};
}
export function getItemInWhseUnitsFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_INWHSE_UNITS_FAILURE,
		payload,
	};
}

export function getItemInStock(payload) {
	return {
		type: actionTypes.GET_ITEM_INSTOCK,
		payload,
	};
}
export function getItemInStockSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_INSTOCK_SUCCESS,
		payload,
	};
}
export function getItemInStockFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_INSTOCK_FAILURE,
		payload,
	};
}

export function getItemInvTrend(payload) {
	return {
		type: actionTypes.GET_ITEM_INV_TREND,
		payload,
	};
}
export function getItemInvTrendSuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_INV_TREND_SUCCESS,
		payload,
	};
}
export function getItemInvTrendFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_INV_TREND_FAILURE,
		payload,
	};
}
export function getNilPickRate(data) {
	return {
		type: actionTypes.GET_NIL_PICK_RATE,
		payload: data,
	};
}
export function getNilPickRateSuccess(result) {
	return {
		type: actionTypes.GET_NIL_PICK_RATE_SUCCESS,
		payload: result,
	};
}
export function getNilPickRateFailure(error) {
	return {
		type: actionTypes.GET_NIL_PICK_RATE_FAILURE,
		payload: error,
	};
}

export function getFirstTimePickRate(data) {
	return {
		type: actionTypes.GET_FIRTS_TIME_PICK_RATE,
		payload: data,
	};
}
export function getFirstTimeRateSuccess(result) {
	return {
		type: actionTypes.GET_FIRTS_TIME_PICK_RATE_SUCCESS,
		payload: result,
	};
}
export function getFirstTimeRateFailure(error) {
	return {
		type: actionTypes.GET_FIRTS_TIME_PICK_RATE_FAILURE,
		payload: error,
	};
}

export function getPreSubstituteRate(data) {
	return {
		type: actionTypes.GET_PRE_SUBSTITUTE_RATE,
		payload: data,
	};
}
export function getPreSubstituteSuccess(result) {
	return {
		type: actionTypes.GET_PRE_SUBSTITUTE_RATE_SUCCESS,
		payload: result,
	};
}
export function getPreSubstituteFailure(error) {
	return {
		type: actionTypes.GET_PRE_SUBSTITUTE_RATE_FAILURE,
		payload: error,
	};
}

export function getPostSubstituteRate(data) {
	return {
		type: actionTypes.GET_POST_SUBSTITUTE_RATE,
		payload: data,
	};
}
export function getPostSubstituteSuccess(result) {
	return {
		type: actionTypes.GET_POST_SUBSTITUTE_RATE_SUCCESS,
		payload: result,
	};
}
export function getPostSubstituteFailure(error) {
	return {
		type: actionTypes.GET_POST_SUBSTITUTE_RATE_FAILURE,
		payload: error,
	};
}

export function getItemNetSalesMapSummary(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES_MAP_SUMMARY,
		payload,
	};
}
export function getItemNetSalesMapSummarySuccess(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES_MAP_SUMMARY_SUCCESS,
		payload,
	};
}
export function getItemNetSalesMapSummaryFailure(payload) {
	return {
		type: actionTypes.GET_ITEM_NET_SALES_MAP_SUMMARY_FAILURE,
		payload,
	};
}

export function getTopBottomGrid(data) {
	return {
		type: actionTypes.GET_TOP_BOTTOM_ITEM_GRID,
		payload: data,
	};
}

export function getTopBottomSalesGrid(data) {
	return {
		type: actionTypes.GET_TOP_BOTTOM_SALES_ITEM_GRID,
		payload: data,
	};
}

export function getWeekOfSupplyStoreData(payload) {
	return {
		type: actionTypes.GET_WEEK_OF_SUPPLY_STORE_DATA,
		payload: payload,
	};
}

export function getWeekOfSupplyStoreSuccess(data) {
	return {
		type: actionTypes.GET_WEEK_OF_SUPPLY_STORE_SUCCESS,
		payload: data,
	};
}

export function getWeekOfSupplyStoreFailure(error) {
	return {
		type: actionTypes.GET_WEEK_OF_SUPPLY_STORE_FAILURE,
		payload: error,
	};
}

export function getWeekOfSupplyDCData(payload) {
	return {
		type: actionTypes.GET_WEEK_OF_SUPPLY_DC_DATA,
		payload: payload,
	};
}

export function getWeekOfSupplyDCSuccess(data) {
	return {
		type: actionTypes.GET_WEEK_OF_SUPPLY_DC_SUCCESS,
		payload: data,
	};
}

export function getWeekOfSupplyDCFailure(error) {
	return {
		type: actionTypes.GET_WEEK_OF_SUPPLY_DC_FAILURE,
		payload: error,
	};
}

export function getItemLocationGridStateData(data) {
	return {
		type: actionTypes.GET_ITEM_LOCATION_GRID_STATE_DATA,
		payload: data,
	};
}

export function getItemLocationGridStateSuccess(data) {
	return {
		type: actionTypes.GET_ITEM_LOCATION_GRID_STATE_SUCCESS,
		payload: data,
	};
}

export function getItemLocationGridStateFailure(error) {
	return {
		type: actionTypes.GET_ITEM_LOCATION_GRID_STATE_FAILURE,
		payload: error,
	};
}

export function getItemLocationGridStoreData(data) {
	return {
		type: actionTypes.GET_ITEM_LOCATION_GRID_STORE_DATA,
		payload: data,
	};
}

export function getItemLocationGridStoreSuccess(data) {
	return {
		type: actionTypes.GET_ITEM_LOCATION_GRID_STORE_SUCCESS,
		payload: data,
	};
}

export function getItemLocationGridStoreFailure(error) {
	return {
		type: actionTypes.GET_ITEM_LOCATION_GRID_STORE_FAILURE,
		payload: error,
	};
}

export function getMapConfig(payload) {
	return {
		type: actionTypes.GET_MAP_KEY,
		payload,
	};
}

export function setMapConfig(input) {
	if (input.success) {
		return {
			type: actionTypes.GET_MAP_KEY_SUCCESS,
			payload: input?.map,
		};
	} else {
		return {
			type: actionTypes.GET_MAP_KEY_FAILURE,
			payload: input.error,
		};
	}
}
